import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  // State
  const isDarkMode = ref(false);
  
  // Initialize theme from local storage or system preference
  const initializeTheme = () => {
    // Check for saved theme preference
    const savedTheme = localStorage.getItem('theme-mode');
    
    if (savedTheme) {
      isDarkMode.value = savedTheme === 'dark';
    } else {
      // Check for system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      isDarkMode.value = prefersDark;
    }
    
    // Apply theme immediately
    applyTheme();
  };
  
  // Apply theme to document
  const applyTheme = () => {
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark-mode');
      document.documentElement.classList.remove('light-mode');
    } else {
      document.documentElement.classList.add('light-mode');
      document.documentElement.classList.remove('dark-mode');
    }
  };
  
  // Toggle theme
  const toggleTheme = () => {
    isDarkMode.value = !isDarkMode.value;
    localStorage.setItem('theme-mode', isDarkMode.value ? 'dark' : 'light');
  };
  
  // Watch for changes to isDarkMode
  watch(isDarkMode, () => {
    applyTheme();
  });
  
  return {
    isDarkMode,
    toggleTheme,
    initializeTheme
  };
});
